import { render, staticRenderFns } from "./DispensedPatientsDataTable.vue?vue&type=template&id=5fd9d060&scoped=true"
import script from "./DispensedPatientsDataTable.vue?vue&type=script&lang=js"
export * from "./DispensedPatientsDataTable.vue?vue&type=script&lang=js"
import style0 from "./DispensedPatientsDataTable.vue?vue&type=style&index=0&id=5fd9d060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd9d060",
  null
  
)

export default component.exports